export enum ACTION_TYPE {
  VIEW = "VIEW",
  DELETE = "DELETE",
  EXPORT = "EXPORT",
  IMPORT = "IMPORT",
  EDIT = "EDIT",
  EXPORT_CSV = "EXPORT.CSV",
  EXPORT_XLSX = "EXPORT.XLSX",
  OPEN_LINK = "SHARE_OPEN_LINK",
  COPY_LINK = "SHARE_COPY_LINK",
  OPEN_LINK_V2 = "SHARE_OPEN_LINK_V2",
  COPY_LINK_V2 = "SHARE_COPY_LINK_V2",
  OPEN_IN_PB = "OPEN_IN_PB",
  CLEAR_CREDS = "CLEAR_CREDS",
  CREATE_PORTFOLIO = "CREATE_PORTFOLIO",
  SHARE = "SHARE",
  COMPARE = "COMPARE",
}

export enum ACTION_FORMAT {
  BUTTON = "BUTTON",
  BUTTON_MENU = "BUTTON_MENU",
}
